<div class="loaders-checkmark" [ngClass]="{'-inverted': inverted}">
    <svg class="loaders-checkmark__svg" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
        <polyline class="loaders-checkmark__path path check" points="100.2,40.2 51.5,88.8 29.8,67.5 " />
    </svg>
</div>